import { render, staticRenderFns } from "./NewsBannerEdit.vue?vue&type=template&id=2436c7e0&scoped=true&"
import script from "./NewsBannerEdit.vue?vue&type=script&lang=js&"
export * from "./NewsBannerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436c7e0",
  null
  
)

export default component.exports